import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '../modules/Home/HomePage';
import Payment from '../modules/Payment/PaymentResult';
import Options from '../modules/Options/Options';
import LegalNotice from '../modules/Footer/LegalNotice';
import Details from '../modules/Details/DetailsPage';
import NotFound from '../modules/NotFound/NotFound';
import StoreSelection from '../modules/Stores/StoreSelection';
import PaymentResult from '../modules/Payment/PaymentResult';
import CGUView from '../modules/Footer/CGUView';
import Infos from '../modules/Footer/Info';
import DetailFooter from '../modules/Details/DetailFooter';
import CGVView from '../modules/Footer/CGVView';

const AppRouter = ({ store, sessionData, config }) => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home/:store?" element={<HomePage store={store} />} />
        <Route path="/payment/:status/:ref" element={<Payment store={store} sessionData={sessionData} config={config} />} />
        <Route path="/options/:anchor" element={<Options store={store} />} />
        <Route path="/stores" element={<StoreSelection store={store} />} />
        <Route path="/legalNotice" element={<LegalNotice store={store} />} />
        <Route path="/details" element={<Details store={store} />} />
        <Route path="/detail" element={<DetailFooter store={store} />} />
        <Route path="/payment/:status/:reference" element={<PaymentResult store={store} />} />

        <Route path="/CGU" element={<CGUView store={store}/>} />
        <Route path="/CGU-V" element={<CGVView store={store}/>} />
        <Route path="/CGV" element={<CGVView store={store}/>} />
        <Route path="/infos" element={<Infos store={store}/>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
